import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { toast } from 'react-toastify';
import Spinner from '../components/Spinner';
import MovieItem from '../components/MovieItem';

export default function GenreDetail() {
  const { genreName } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    async function fetchMovies() {
      setLoading(true);
      try {
        const moviesQuery = query(
          collection(db, "movies"),
          where("genre", "==", genreName.charAt(0).toUpperCase() + genreName.slice(1)),
          orderBy("timestamp", "desc")
        );
        const moviesSnap = await getDocs(moviesQuery);
        setMovies(moviesSnap.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      } catch (error) {
        toast.error("Failed to load movies");
        console.error("Error fetching movies:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchMovies();
  }, [genreName]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <main className="min-h-screen py-6 px-2 sm:px-4">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-[#FF1493] mb-10 px-2 sm:px-0">
          {genreName.charAt(0).toUpperCase() + genreName.slice(1)} Movies
        </h1>
        {movies.length > 0 ? (
          <div className="movie-grid">
            {movies.map((movie) => (
              <MovieItem
                key={movie.id}
                movie={{ ...movie.data, id: movie.id }}
                onClick={() => navigate(`/movie/${movie.id}`)}
              />
            ))}
          </div>
        ) : (
          <p className="text-gray-400 text-center py-6">
            No movies available in this genre yet.
          </p>
        )}
      </div>
    </main>
  );
}